import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
export var DEFAULT_ROUTE_CONTROL_PARAMS = {
  autofocus: true,
  maxWidth: '330px',
  position: {
    right: 72,
    top: 24
  },
  showHeader: true,
  title: 'Построить маршрут'
};
export var STICKY_LEFT_ROUTE_CONTROL_PARAMS = _objectSpread(_objectSpread({}, DEFAULT_ROUTE_CONTROL_PARAMS), {}, {
  maxWidth: '358px',
  position: {
    top: 0,
    left: 0
  }
});
export var STICKY_BOTTOM_ROUTE_CONTROL_PARAMS = _objectSpread(_objectSpread({}, DEFAULT_ROUTE_CONTROL_PARAMS), {}, {
  maxWidth: '100%',
  floatIndex: 9,
  position: {
    bottom: 0,
    left: 0,
    right: 0
  }
});
export var DEFAULT_ROUTE_CONTROL_OPTIONS = {
  allowSwitch: false,
  types: {
    pedestrian: true,
    masstransit: true,
    auto: true
  }
};
export var DEFAULT_ROUTE_CONTROL_STATE = {
  type: 'pedestrian'
};
export var DEFAULT_CLOSE_BUTTON_POSITION = {
  right: 86,
  top: 38
};
export var STICKY_LEFT_CLOSE_BUTTON_POSITION = {
  left: 330,
  top: 12
};
export var STICKY_BOTTOM_CLOSE_BUTTON_POSITION = {
  right: 16,
  bottom: 204
};
export var MULTI_ROUTE_CONFIG = {
  routeActivePedestrianSegmentStrokeColor: '#0468FF',
  routeActivePedestrianSegmentStrokeStyle: 'shortdot',
  routeActiveStrokeColor: '#0468FF',
  routeActiveStrokeWidth: 4,
  routeActiveTransportSegmentStrokeColor: '#0468FF',
  routeActiveWalkSegmentStrokeColor: '#0468FF',
  routeActiveWalkSegmentStrokeStyle: 'shortdot',
  routeStrokeWidth: 4,
  wayPointFinishIconFillColor: '#0468FF',
  wayPointStartIconFillColor: '#FF1F34'
};
export var BUTTON_LAYOUT = "\n  <ymaps class=\"ymaps_maps-button__close\">\n      <ymaps class=\"ymaps_maps-button-icon_close\" />\n  </ymaps>\n";